"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  margin-right: 10px;\n  font-size: 1.4rem;\n  line-height: 2rem;\n  color: ", ";\n  cursor: pointer;\n  transition: color 0.1s ease-in-out;\n\n  &:last-of-type {\n    margin-right: 0;\n  }\n\n  &:hover {\n    color: ", ";\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  display: none;\n  justify-content: flex-start;\n  align-items: center;\n\n  span {\n    margin: 0 10px;\n    font-size: 1.4rem;\n    line-height: 2rem;\n    color: ", ";\n  }\n\n  ", ":hover & {\n    display: flex;\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  margin-bottom: 10px;\n\n  .title {\n    font-size: 1.4rem;\n    line-height: 2rem;\n    color: ", ";\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  & p {\n    font-size: 1.6rem;\n    line-height: 130%;\n    color: ", ";\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  margin-right: 20px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: flex-start;\n  width: 100%;\n  font-family: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var CommentBox = function CommentBox(_ref) {
  var title = _ref.title,
      icon = _ref.icon,
      children = _ref.children,
      editHandler = _ref.editHandler,
      deleteHandler = _ref.deleteHandler;
  var IconToRender;

  if (icon !== '') {
    IconToRender = _react.default.createElement(CommentBoxIcon, null, icon);
  }

  return _react.default.createElement(CommentBoxWrapper, null, IconToRender, _react.default.createElement(CommentBoxContent, null, _react.default.createElement(CommentBoxHeader, null, _react.default.createElement("span", {
    className: "title"
  }, title), _react.default.createElement(CommentBoxActions, null, _react.default.createElement("span", null, " | "), _react.default.createElement(CommentBoxAction, {
    onClick: editHandler
  }, "Edit"), _react.default.createElement(CommentBoxAction, {
    onClick: deleteHandler
  }, "Delete"))), children));
};

var CommentBoxWrapper = _styledComponents.default.div(_templateObject(), function (_ref2) {
  var theme = _ref2.theme;
  return theme.font;
});

var CommentBoxIcon = _styledComponents.default.div(_templateObject2());

var CommentBoxContent = _styledComponents.default.div(_templateObject3(), function (_ref3) {
  var theme = _ref3.theme;
  return theme.typo.text;
});

var CommentBoxHeader = _styledComponents.default.div(_templateObject4(), function (_ref4) {
  var theme = _ref4.theme;
  return theme.labels.defaultText;
});

var CommentBoxActions = _styledComponents.default.div(_templateObject5(), function (_ref5) {
  var theme = _ref5.theme;
  return theme.labels.defaultText;
}, CommentBoxWrapper);

var CommentBoxAction = _styledComponents.default.a(_templateObject6(), function (_ref6) {
  var theme = _ref6.theme;
  return theme.labels.defaultText;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.brand.primary;
});

CommentBox.propTypes = {
  /** Title displayed next to the actions. */
  title: _propTypes.string,

  /** Icon to be displayed on the left side. */
  icon: _propTypes.node,
  children: _propTypes.node,

  /** Function to be ran when 'edit' is clicked. */
  editHandler: _propTypes.func,

  /** Function to be ran when 'delete' is clicked. */
  deleteHandler: _propTypes.func,
  id: _propTypes.int
};
var _default = CommentBox;
exports.default = _default;